import React from 'react';
import cx from 'classnames';
import { isRtlLanguage } from 'helpers/isRtlLanguage';

import { EMAIL_VERIFICATION_STATE, useEmailVerification, useLabel, useSettings } from '@atlas/core';
import { Button, Label, TranslateWithLinks } from '@atlas/ui';

const VerifyBlock = () => {
  const { lang } = useSettings();
  const { email, loading, resend, timeDisplay, verificationState } = useEmailVerification();

  const defaultMessage = useLabel('email_verification_profile_default');
  const cooldownMessage = useLabel('email_verification_profile_cooldown', { time: timeDisplay });
  const cooldownEmailSentMessage = useLabel('email_verification_profile_cooldown_email_sent', {
    email,
  });
  const limitReachedMessage = useLabel('email_verification_profile_limit_reached');
  const limitReachedEmailSentMessage = useLabel(
    'email_verification_profile_limit_reached_email_sent',
    { email },
  );

  const rtlClass = cx({ rtl: isRtlLanguage({ lang }) });

  if (verificationState === EMAIL_VERIFICATION_STATE.HIDDEN) {
    return (
      <div className="varified-badge absolute">
        <Label className="verified-badge-label" message="verified" />
      </div>
    );
  }

  if (verificationState === EMAIL_VERIFICATION_STATE.VERIFY_EMAIL) {
    if (!email) {
      return null;
    }

    return (
      <div className={cx('verify-email-container', rtlClass)}>
        <Button
          block
          disabled={loading}
          label="email_verification_profile_verify_email"
          loading={loading}
          onClick={resend}
          type="primary"
        />
      </div>
    );
  }

  const popupTitleClass = cx('verify-email-container popup-title-content', rtlClass);

  if (verificationState === EMAIL_VERIFICATION_STATE.DEFAULT) {
    return (
      <div className={popupTitleClass}>
        <span className="main-label">
          <TranslateWithLinks actions={resend} translate={defaultMessage} />
        </span>
      </div>
    );
  }

  if (verificationState === EMAIL_VERIFICATION_STATE.COOLDOWN) {
    return (
      <div className={popupTitleClass}>
        <span className="main-label">
          <TranslateWithLinks translate={cooldownMessage} />
        </span>
        <span className="sub-label">
          <TranslateWithLinks translate={cooldownEmailSentMessage} />
        </span>
      </div>
    );
  }

  return (
    <div className={popupTitleClass}>
      <span className="main-label">
        <TranslateWithLinks translate={limitReachedMessage} />
      </span>
      <span className="sub-label">
        <TranslateWithLinks translate={limitReachedEmailSentMessage} />
      </span>
    </div>
  );
};

export default VerifyBlock;
